'use client';

import { useState } from 'react';
import { useForm } from 'react-hook-form';

import { resetPassword } from '@/api/auth';
import { useTranslation } from '@/i18n/client';
import { WithLang } from '@/types/general';

import { AuthPopupKeys, AuthProps } from './auth.types';
import { AuthResponse } from './AuthResponse';

interface UpdatePasswordForm {
    password: string;
}

export const PasswordReset = (props: WithLang<AuthProps & { token: string }>) => {
    const { t } = useTranslation(props.lang, 'auth');

    const [isResponseSuccess, setIsResponseSuccess] = useState<null | boolean>(null);

    const {
        register,
        handleSubmit,
        formState: { isValid },
    } = useForm<UpdatePasswordForm>();

    const onSubmit = async (data: UpdatePasswordForm) => {
        const response = await resetPassword(props.token, data.password);
        setIsResponseSuccess(response);
    };

    const responseContent = isResponseSuccess
        ? {
              title: t('titles.reset'),
              message: t('messages.resetPasswordSuccess'),
          }
        : {
              title: t('titles.reset'),
              message: t('messages.resetPasswordFailed'),
          };

    return isResponseSuccess === null ? (
        <>
            <p className="whitespace-nowrap text-2xl xs:text-xl">{t('titles.reset')}</p>
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-y-4 border-b border-opacity-30 pb-6">
                <input
                    type="password"
                    {...register('password', { required: true })}
                    className="input-primary"
                    placeholder={t('placeholders.password')}
                ></input>
                <button
                    type="submit"
                    disabled={!isValid}
                    onSubmit={handleSubmit(onSubmit)}
                    className="btn-accent mt-4 py-2 text-base font-semibold"
                >
                    {t('buttons.resetPassword')}
                </button>
            </form>
            <div className="mx-auto flex w-full flex-col items-stretch justify-center gap-x-2 gap-y-3 xs:w-5/6 md:flex-row md:items-center">
                <button
                    onClick={() => props.onRedirect(AuthPopupKeys.LOGIN)}
                    className="btn-primary flex-1 border-accent text-sm md:border-solid"
                >
                    {t('buttons.loginFull')}
                </button>
                {/*<button*/}
                {/*    onClick={() => props.onRedirect(AuthPopupKeys.SIGNUP)}*/}
                {/*    className="btn-primary flex-1 border-accent text-sm md:border-solid"*/}
                {/*>*/}
                {/*    {t('buttons.signup')}*/}
                {/*</button>*/}
            </div>
        </>
    ) : (
        <AuthResponse
            lang={props.lang}
            isSuccess={isResponseSuccess}
            onClose={props.onClose}
            responseContent={responseContent}
            onRedirect={(popupKey) => props.onRedirect(popupKey)}
        />
    );
};
